<template>
  <BaseModal ref="modal">
    <UiModalDialog>
      <template #header>{{ ls(def.name) }}</template>
      <template #header-extra>
        <UiInputRound class="jps-round-input" v-model="filter"/>
      </template>
      <div class="jps-modal-content layout-col generated-10">
        <div
          class="search-facet-line"
          :class="{ 'is-selected': isSelected(value) }"
          v-for="(count, value) in sortedFacet"
          :key="value"
        >
          <BaseCheckbox
            :model-value="isSelected(value)"
            @update:model-value="select(value)"
            class="checkbox"
          >
            <SearchFacetValue
              class="value is-size-7-touch"
              :facet="facet"
              :def="def"
              :value="value"
            />
            <span class="count is-size-7-touch">{{ count }}</span>
          </BaseCheckbox>
        </div>
      </div>
      <template #buttons>
        <button @click="modal.reject()">{{ ls(dapLangGlobal.cancel) }}</button>
        <button @click="modal.resolve(selected)">
          {{ lss('絞り込み', 'Narrow down') }}
        </button>
      </template>
    </UiModalDialog>
  </BaseModal>
</template>

<script lang="ts" setup>
import { dapLangGlobal } from '#imports'
import type { BaseModal } from '#components'
import { useSearchFieldExpand } from '~/components/search/search-field/useSearchFieldExpand'
import type { SearchFieldExpandProps } from '~/components/search/search-field/useSearchFieldExpand'

const { ls, lss } = useI18n()

interface Props extends SearchFieldExpandProps {
}
const props = withDefaults(defineProps<Props>(), {
})

const { init, selected, select, isSelected, sortedFacet, filter } = useSearchFieldExpand(props)

const modal = ref<InstanceType<typeof BaseModal>>()
const openAwait = async () => {
  init()
  return await modal.value.openAwait<string[]>()
}
defineExpose({ openAwait })
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.jps-round-input {
  background: $white !important;
  width: auto !important;
  margin-left: 1rem  !important;
  margin-right: 1rem  !important;
}

.generated-10 {
  gap: 1rem;
}
</style>
